module.exports = __webpack_public_path__ + "static/media/banner_bg_landingpage.c6c21818.png";